import api from './api'

const websiteContactService = {
  getWebsiteContacts: ({ search = '', domainName = '', skipCount = 0, totalCount = 10 }) =>
    api.get('/api/WebsiteContacts', {
      params: {
        Search: search,
        domainName: domainName || undefined,
        SkipCount: skipCount,
        TotalCount: totalCount
      }
    })
}

export default websiteContactService
